import papaparse from 'papaparse'
import { isInvalidExtension, isInvalidFile } from '@/helpers'

/**
 * Default csv parser
 *
 * @param {File} file
 * @param {Boolean} hasHeader
 * @returns {Promise<any>}
 */
export const defaultParser = (file, hasHeaders = true) => {
  return new Promise((resolve, reject) => {
    const validation = validate(file)

    if (validation.errors.length > 0) {
      reject(validation)
    }

    const { name } = file

    papaparse.parse(file, {
      skipEmptyLines: true,
      header: hasHeaders,
      // On parsing completion
      complete ({ data: items, meta: { fields: headers } }) {
        if (headers === undefined) {
          headers = []
        } else {
          headers = headers.map(header => {
            return {
              value: header,
              field: null
            }
          })
        }
        resolve({
          headers,
          items,
          name
        })
      }
    })
  })
}

/**
 * Validate csv file
 *
 * @param {File} file
 *
 * @return {array}
 */
export const validate = (file) => {
  let validation = {
    name: file.name,
    errors: []
  }

  const invalidExtension = isInvalidExtension(file.name, ['csv'])
  if (invalidExtension) {
    validation.errors.push(invalidExtension)
  }

  const invalidFile = isInvalidFile(file)
  if (invalidFile) {
    validation.errors.push(invalidExtension)
  }

  return validation
}
